import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const ZeikeisanKbn = props => {
  return <Dropdown.Static kubunKey='zei_keisan_kbn' {...props} />
}
